<template>
  <generic-list
    :query-fields="queryFields"
    :columns="columns"
    :form-fields="formFields"
    :editable-fields="editableFields"
    :fetch-data="fetchData"
    :add-data="addData"
    :update-data="updateData"
    :delete-data="deleteData"
    :add-fields="addFields"
  />
</template>

<script>
import GenericList from '@/components/GenericList.vue';
import { getLotteries, createLottery, updateLottery, deleteLottery } from '@/api/lottery';

export default {
  name: 'LotteryManagement',
  components: {
    GenericList
  },
  data() {
    return {
      queryFields: [
        { prop: 'code', label: '彩票编码', type: 'input' },
        { prop: 'name', label: '彩票名称', type: 'input' },
        { prop: 'status', label: '状态', type: 'select', options: [
          { label: '停用', value: 0 },
          { label: '启用', value: 1 }
        ]}
      ],
      columns: [
        { prop: 'code', label: '彩票编码' },
        { prop: 'name', label: '彩票名称' },
        { prop: 'mobile_image', label: '手机端展示图' },
        { prop: 'pc_image', label: 'PC端展示图' },
        { prop: 'status', label: '状态' },
        { prop: 'access_group', label: '进入权限' },
        { prop: 'access_requirement', label: '进入要求' }
      ],
      formFields: [
        { prop: 'code', label: '彩票编码', type: 'input' },
        { prop: 'name', label: '彩票名称', type: 'input' },
        { prop: 'mobile_image', 
    label: '手机端展示图', 
    type: 'image-upload', 
    action: process.env.VUE_APP_API_BASE_URL + '/upload', 
    headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') },
    limit: 1,
    accept: 'image/*' },
        { prop: 'pc_image', 
    label: 'PC端展示图', 
    type: 'image-upload', 
    action: process.env.VUE_APP_API_BASE_URL + '/upload', 
    headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') },
    limit: 1,
    accept: 'image/*' },
        { prop: 'status', label: '状态', type: 'select', options: [
          { label: '停用', value: 0 },
          { label: '启用', value: 1 }
        ]},
        { prop: 'access_group', label: '进入权限', type: 'input' },
        { prop: 'access_requirement', label: '进入要求', type: 'input', inputType: 'number' }
      ],
      editableFields: [
        'code',
        'name',
        'mobile_image',
        'pc_image',
        'status',
        'access_group',
        'access_requirement'
      ],
      addFields: [
        'code',
        'name',
        'mobile_image',
        'pc_image',
        'status'
      ]
    };
  },
  methods: {
    async fetchData(queryParams) {
      try {
        const response = await getLotteries(queryParams);
        return {
          data: {
            list: response.data.rows,
            total: response.data.count
          }
        };
      } catch (error) {
        console.error('API Error:', error);
        throw error;
      }
    },
    addData(data) {
      return createLottery(data);
    },
    updateData(data) {
      const editableData = {};
      this.editableFields.forEach(field => {
        if (data[field] !== undefined) {
          editableData[field] = data[field];
        }
      });
      return updateLottery(editableData);
    },
    deleteData(id) {
      return deleteLottery(id);
    }
  }
};
</script>

<style scoped>
/* 添加自定义样式 */
</style>